module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-M05-clean-de9b6e5c9f4b854bce1b3e6df9922d5c.png";